module.exports = __webpack_public_path__ + "img/ZNZBZZYJC_9.ea6fd79e.jpg";